import React from 'react';

const Skeleton = () => (
    <>
        {[...Array(5)].map((_, i) => (
            <div key={i} className="row mx-0 border-bottom py-3">
                <div className="col-3 col-sm-2">
                    <div className="bg-light rounded" style={{ width: 60, height: 60 }} />
                </div>
                <div className="col-9 col-sm-10">
                    <div className="bg-light rounded mb-2" style={{ height: 18 }} />
                    <div className="bg-light rounded" style={{ height: 14, width: 80 }} />
                </div>
            </div>
        ))}
    </>
);

export default Skeleton;


